import React, { useState } from 'react'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAddressCard, FaBars, FaBook, FaCaretDown, FaCaretUp, FACaretUp, FaCartPlus, FaChartBar, FaCog, FaCreditCard, FaHistory, FaHome, FaKey, FaList, FaListUl, FaMailBulk, FaMicrosoft, FaPhotoVideo, FaPlus, FaPlusCircle, FaPoll, FaPollH, FaRecordVinyl, FaScrewdriver, FaStore, FaUser, FaUsers, FaVideo, FaVoteYea, FaVrCardboard } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Alert from '../components/Alert';

const SideNav = () => {
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const Navigate = useNavigate();
    const user = useSelector(state => state.user.payload);
    const notActivated = () => {
        Swal.fire({
                // title: '<u>Create New Inventory</u>',
                html: `<h5 style='color:red'> This feature is not activated.</h5>`,
                icon: 'error',
                confirmButtonText: `Close`,
                confirmButtonColor: 'red',
                showCloseButton: true,
                confirmButtonAriaLabel: 'ests'
                // close

            });
    }
    useEffect(() => {
        // console.log(window.innerWidth);
        if(window.innerWidth < "430"){
           let element =  document.getElementsByClassName('sidebar')[0];
            element.classList.add('close');
            // document.getElementsByClassName('bell')[0].classList.a 
            
        } 
        // console.log(user.access_type)
    }, [])
  return (
    <div class="sidebar bg">
        
    <div id='logo' class="logo">
    <i class="image p"> 
        {/* <FaUser /> */}
        <img src={user.image} className='px-1' alt="Logo"
          style={{ 
            borderRadius: '50%',
            width:'65px',
            height: '65px',
            backgroundColor: 'white'
            // borderRadius: '10%'
           }}
          />
    </i>
    <span class="logo-name mx-1"
    style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        alignContent: 'center'
        
     }}
    >
        
        {user.name}
        {/* {
            document.getElementById('logo') && 
            document.getElementById('logo').className == 'show' ?
            <FaCaretUp size={12} className='mt-1 ms-2'/> :
            <FaCaretDown size={18} className='mt-1 ms-2' />
        }  */}
    </span>
        {/* <ul style={{ 
            padding: "8px 2px 5px 75px",
            marginTop: "-10px",
            background: "#2a3431",
            display: 'none',
            transition: "all 0.3s ease",
            color: 'white'
         }}> 
            <li>
                Sign-out
            </li>
        </ul> */}
    </div>

    <ul class="nav-list">
        <li id='dashboard' onClick={()=> {
            Navigate('dashboard')
            // console.log(window.innerWidth);
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}>
            <a href="#">
            <i class=""><FaHome /></i>
            <span class="link-name">Dashboard</span>
            </a>

            <ul class="sub-menu blank">
            <li><a href="#" class="link-name">Dashboard</a></li>
            </ul>
        </li>
        { user.access_type < 3 &&
        <>
        <li id='users'
        onClick={(e) => {
            document.getElementById('users').classList.toggle('show');
            setSubMenuOpen(!subMenuOpen);
        }}
        >
            <div class="icon-link">
            <a href="#"  >
                <i><FaUsers /></i>
                <span class="link-name">Users</span>
            </a>
            <i class="arrow" > {document.getElementById('users') && document.getElementById('users').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
            
            </div>

            <ul class="sub-menu">
            <li
            onClick={()=> {
                Navigate('new_user')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaPlus className='me-1' />
                    New User
                </a>
            </li>
            <li
            onClick={()=> {
                Navigate('users')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaList className='me-1' />
                    View Users
                </a>
            </li>
            </ul>
        </li>
        <li id='vote'
        onClick={(e) => {
            document.getElementById('vote').classList.toggle('show');
            setSubMenuOpen(!subMenuOpen);
        }}
        >
            <div class="icon-link">
            <a href="#"  >
                <i><FaPoll /></i>
                <span class="link-name">Vote</span>
            </a>
            <i class="arrow" > {document.getElementById('vote') && document.getElementById('vote').className === 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
            
            </div>

            <ul class="sub-menu">
            <li
            onClick={()=> {
                
                // if('vote' === true){
                    Navigate('vote')
                    if(window.innerWidth < '430'){
                        let sidebar = document.querySelector(".sidebar");
                        sidebar.classList.toggle("close");
                    }
                // }else{
                //     Swal.fire("Voting has not commence yet!", "2025 Best Staffs Voting Will Commence Spon!!!.", 'info' );
                // }
                }}
            >
                <a href="#">
                <FaPlus className='me-1' />
                    Vote
                </a>
            </li>
            <li
            onClick={()=> {
                if('vote' === true){
                    Navigate('vote_result')
                    if(window.innerWidth < '430'){
                        let sidebar = document.querySelector(".sidebar");
                        sidebar.classList.toggle("close");
                    }
                }else{
                    Swal.fire("Voting Result!", "2025 Best Staffs Voting Result is not yet available!!!.", 'info' );
                }
                }}
            >
                <a href="#">
                <FaListUl className='me-1' />
                    Vote Results
                </a>
            </li>
            {
                Number(user.access_type) < 2 &&
                <li
                onClick={()=> {
                    
                        Navigate('vote_config')
                        if(window.innerWidth < '430'){
                            let sidebar = document.querySelector(".sidebar");
                            sidebar.classList.toggle("close");
                        }
                    
                    }}
                >
                    <a href="#">
                    <FaScrewdriver className='me-1' />
                        Config
                    </a>
                </li>
            }
            </ul>
        </li>
        {
            user.access_type === '!' &&
            <>
                <li id='message'
        onClick={(e) => {
            document.getElementById('message').classList.toggle('show');
            setSubMenuOpen(!subMenuOpen);
        }}
        >
            <div class="icon-link">
            <a href="#"  >
                <i><FaMailBulk /></i>
                <span class="link-name">Message</span>
            </a>
            <i class="arrow" > {document.getElementById('message') && document.getElementById('message').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
            
            </div>

            <ul class="sub-menu">
            <li
            onClick={()=> {
                notActivated();
                // Navigate('new_message')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaPlus className='me-1' />
                    New Message
                </a>
            </li>
            <li
            onClick={()=> {
                notActivated();
                // Navigate('messages')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaList className='me-1' />
                View Messages
                </a>
            </li>
            </ul>
        </li>
        <li id='report'
        onClick={(e) => {
            document.getElementById('report').classList.toggle('show');
            setSubMenuOpen(!subMenuOpen);
        }}
        >
            <div class="icon-link">
            <a href="#"  >
                <i><FaChartBar /></i>
                <span class="link-name">Report</span>
            </a>
            <i class="arrow" > {document.getElementById('report') && document.getElementById('report').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
            
            </div>

            <ul class="sub-menu">
            <li
            onClick={()=> {
                notActivated();
                // Navigate('new_report')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaPlus className='me-1' />
                    New Report
                </a>
            </li>
            <li
            onClick={()=> {
            notActivated();
                // Navigate('reports')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaList className='me-1' />
                    View Reports
                </a>
            </li>
            </ul>
        </li>
        <li id='inventory'
        onClick={(e) => {
            document.getElementById('inventory').classList.toggle('show');
            setSubMenuOpen(!subMenuOpen);
        }}
        >
            <div class="icon-link">
            <a href="#"  >
                <i><FaStore /></i>
                <span class="link-name">Inventory</span>
            </a>
            <i class="arrow" > {document.getElementById('inventory') && document.getElementById('inventory').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
            
            </div>

            <ul class="sub-menu">
            <li
            onClick={()=> {
                notActivated();
                // Navigate('new_report')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaPlus className='me-1' />
                    New Inventory
                </a>
            </li>
            <li
            onClick={()=> {
                notActivated();
                // <Alert title={'Create New Inventory'} message={'This Feature is not activated yet!!!'} />
                // Navigate('reports')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaList className='me-1' />
                View Inventories
                </a>
            </li>
            </ul>
        </li>
        </>
            
        }
        </>
        }
        <li id='handbook' onClick={()=> {
            Navigate('/handbook')
            // console.log(window.innerWidth);
            if(window.innerWidth < '430'){
                let sidebar = document.querySelector(".sidebar");
                sidebar.classList.toggle("close");
            }
            }}>
            <a href="#">
            <i class=""><FaBook /></i>
            <span class="link-name">Staffs HandBook</span>
            </a>
        </li>
        {user.access_type > 3 &&
        <li id='vote' onClick={()=> {
            if('vote' === true){
                Navigate('/vote')
                    // console.log(window.innerWidth);
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
            }else{
                Swal.fire("Voting has not commence yet!", "2025 Best Staffs Voting Will Commence Spon!!!.", 'info' );
            }
            }}>
            <a href="#">
            <i class=""><FaVoteYea /></i>
            <span class="link-name"
            style={{ color: ''}}
            >Vote</span>
            </a>
        </li>
        }
        <li id='settings'
        onClick={(e) => {
            document.getElementById('settings').classList.toggle('show');
            setSubMenuOpen(!subMenuOpen);
        }}
        >
            <div class="icon-link ">
            <a href="#">
                <i class="float-end"><FaCog /></i>
                <span class="link-name">Settings </span>
            </a>
            <i class="arrow" > {document.getElementById('settings') && document.getElementById('settings').className == 'show' ? <FaCaretUp />: <FaCaretDown />} </i>
            </div>

            <ul class="sub-menu">
            { user.access_type < 3 &&
                <li
                onClick={()=> {
                    Navigate('/profile')
                    if(window.innerWidth < '430'){
                        let sidebar = document.querySelector(".sidebar");
                        sidebar.classList.toggle("close");
                    }
                    }}
                >
                    <a href="#">
                    <FaUser className='me-1' />
                        User Profile
                    </a>
                </li>
            }
            <li
            onClick={()=> {
                Navigate('change_password')
                if(window.innerWidth < '430'){
                    let sidebar = document.querySelector(".sidebar");
                    sidebar.classList.toggle("close");
                }
                }}
            >
                <a href="#">
                <FaKey className='me-1' />
                    Change Password
                </a>
            </li>
            </ul>
        </li>
        {/* Side Nav Footer */}
        <div class="profile-details">
            {/* UXTECH Trade-Mark */}
            {/* <div class="profile-content">
                
                <img src="logo.png" alt="" />
            </div>

            <div class="name-job">
                <div class="name">by uxtech</div>
                <div class="job text-center"> www.uxtech.ng </div>
            </div> 
            <i class="fas fa-right-to-bracket"></i>  */}
        </div>
    </ul>
    </div>
  )
}

export default SideNav